import { render } from "./approvazioneLoginModal.vue?vue&type=template&id=4ad2b238&ts=true"
import script from "./approvazioneLoginModal.vue?vue&type=script&lang=ts"
export * from "./approvazioneLoginModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__